import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Quantity } from 'src/views/components/QuantityIncrementer'
import debounce from 'lodash/debounce'
// import { Dropdown } from 'react-bootstrap'
import './substyles.scss'

@observer
class SubscriptionQuantityDropdown extends React.Component {
  @observable selectedQuantity = this.props.quantity
  @observable isQuantityCallInProgress = false
  componentDidUpdate = prevProps => {
    if (prevProps.quantity != this.props.quantity) {
      this.selectedQuantity = this.props.quantity
    }
  }
  handleQuantityChange = async (count, cartItemId) => {
    this.isQuantityCallInProgress = true
    const { handleCartQuantityChange } = this.props
    const isSuccess = await handleCartQuantityChange(
      count,
      this.props.cartItemId,
      this.props
    )

    if (!isSuccess) {
      this.selectedQuantity = this.props.quantity
    }
    this.isQuantityCallInProgress = false
  }

  debounceQuantityChange = count => {
    this.selectedQuantity = count
    this.debounceQuantityUpdate(count)
  }

  debounceQuantityUpdate = debounce(async count => {
    await this.handleQuantityChange(count)
  }, 700)

  render() {
    const defaultVal = this.props.isPVAssistant ? 1 : this.selectedQuantity
    const shouldDisable =
      this.props.isPVAssistant ||
      this.isQuantityCallInProgress ||
      this.props.isGift ||
      this.props?.disableActions ||
      this.props?.isProductStatusInactive
    return (
      <div
        className={`quantity-dropdown-container ${
          shouldDisable ? 'disable' : ''
        }`}>
        <Quantity
          onQuantityChange={this.debounceQuantityChange}
          defaultValue={defaultVal}
          disableTabIndex={shouldDisable}
        />
      </div>
    )
  }
}
export { SubscriptionQuantityDropdown }
export default SubscriptionQuantityDropdown
